import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as AuthenticationSelectors from './authentication.selectors';

@Injectable()
export class AuthenticationFacade {
  excludeAnalytics$ = this.store.pipe(select(AuthenticationSelectors.getAnalyticsExcludeStatus));
  authenticated$ = this.store.pipe(select(AuthenticationSelectors.getAuthenticationStatus));
  authencationTokenSub$ = this.store.pipe(select(AuthenticationSelectors.getAuthenticationTokenSub));
  userInformation$ = this.store.pipe(select(AuthenticationSelectors.getUserInformation));

  constructor(private readonly store: Store) {}
}
